var React = require('react');

function HorizontalRule (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M640 240.13v31.74A16 16 0 0 1 624.13 288H15.87A16 16 0 0 1 0 271.87v-31.74A16 16 0 0 1 15.87 224h608.26A16 16 0 0 1 640 240.13z","className":"fa-secondary","key":1})]);
}

HorizontalRule.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = HorizontalRule;

HorizontalRule.default = HorizontalRule;
